// extracted by mini-css-extract-plugin
export default {"primary":"#003a74","secondary":"#0b72d9","error":"#d15744","boxWrapper":"vehicles_boxWrapper__PvJiq"};